// Import packages
import React, { Component } from "react";
import { connect } from "react-redux";
import { Switch, DatePicker } from "antd";

//import styles
import '../../../assets/styles/containerStyles/appended-product-section.scss';

// Import components
import PageWrapper from '../../../components/pageContentViews/pageWrapper'
import MediaSelectorModal from "../../../components/media/MediaSelectorModal";
import { InputGroup } from "../../../components/uiElements/inputGroup";
import { LinkButton } from "../../../components/buttons/buttons";
import { MediaFileCard } from "../../../components/media/MediaFileCard";

// Import utils
import {
    changeStateField, disabledEndDate,
    getInputValues, getPatchReqData, getPostReqData,
    getTranslatableInputValues, getTranslationsInitialValues,
    initTranslations,
} from "../../../utils/helperFunctions";
import { mapStateToProps } from "../../../redux/mapStateToProps";
import {
    CreatePartnerOffer,
    GetPartnerOfferById,
    UpdatePartnerOfferById,
} from "../../../redux/actions";
import { validateTranslations } from "../../../utils/validateTranslations";
import { ACCEPT_IMAGE_TYPES } from "../../../constants/acceptedTypes";
import { LanguageTabs } from "../../../components/uiElements/Tabs";
import { MAIN_LANGUAGE_TYPES } from "../../../constants/constsTypes";
import { transformImage } from "../../../utils/transformImage";
import { Editor } from "../../../components/uiElements/Editor";
import swal from "sweetalert";

class AddEditPartnerOffer extends Component {
    constructor (props) {
        super(props);
        this.translationsFields = [
            'title',
            'description',
        ];
        this.state = {
            fieldsData: {
                translations: initTranslations(this.translationsFields),
                image: null,
                mobile: null,
                mobile_cover: null,
                is_hidden: false,
                link: '',
                slug: '',
            },
            errors: {},
            errorsTabs: [],
            isEditing: !!props?.id,
            languageTab: MAIN_LANGUAGE_TYPES.en,
            requestLoading: false,
            mediaModalType: '',
        };
        this.updatedDataMap = new Map();
        this.currentData = null;
        this.changeLanguageTab = changeStateField.bind(this, 'languageTab');
        this.getInputValues = getInputValues.bind(this);
        this.getTranslatableInputValues = getTranslatableInputValues.bind(this);
        this.getPatchReqData = getPatchReqData.bind(this);
        this.getPostReqData = getPostReqData.bind(this);
        this.addEditOffer = this.addEditOffer.bind(this);
    }

    async componentDidMount () {
        const { isEditing } = this.state;

        if (isEditing) {
            await this.props.GetPartnerOfferById(this.props.id);
            const editingData = this.props.partnerOfferById
            if (editingData) {
                const initStateData = {
                    translations: getTranslationsInitialValues(editingData.translations, ['title', 'description']),
                    image: editingData?.image_object_name ?
                        transformImage(editingData.image_object_name, editingData.image_url)
                        : null,
                    mobile: editingData?.mobile_object_name ?
                        transformImage(editingData.mobile_object_name, editingData.mobile_url)
                        : null,
                    mobile_cover: editingData?.mobile_cover_object_name ?
                        transformImage(editingData.mobile_cover_object_name, editingData.mobile_cover_url)
                        : null,
                    is_hidden: editingData?.is_hidden,
                    link: editingData?.link || "",
                    slug: editingData?.slug || "",
                }
                this.currentData = JSON.parse(JSON.stringify(initStateData));
                this.setState({
                    fieldsData: initStateData,
                });
            }
        }
    }

    getMedia (type, mediaArray) {
        const { fieldsData, errors } = this.state;
        this.setState({
            fieldsData: {
                ...fieldsData,
                [type]: mediaArray[0],
            },
            errors: {
                ...errors,
                [type]: false
            }
        })
    }

    deleteMedia (type) {
        const { fieldsData, } = this.state;
        this.setState({
            fieldsData: {
                ...fieldsData,
                [type]: null,
            }
        })
    }

    toggleMediaModalType (type = '') {
        this.setState({
            mediaModalType: type
        })
    }

    async addEditOffer () {
        await this.setState({
            requestLoading: true
        });
        const { translations, image, slug} = this.state.fieldsData;
        const translationRequiredFields = ['title', 'description']
        const validationTr = validateTranslations(translations, translationRequiredFields)
        let result = validationTr.result;
        const errors = { ...validationTr.errors };

        if (!image) {
            errors.image = true;
            result = false;
        }

        if (!slug) {
            errors.slug = true;
            result = false;
        }

        if (result) {
            if (!this.state.isEditing) {
                let reqData = this.getPostReqData(this.state.fieldsData);
                this.props.CreatePartnerOffer(reqData).catch((error) => {
                    if (error && error.response && error.response.status === 409) {
                        swal({
                            title: "Չհաջողվեց!",
                            text: "Slug -ը զբաղված է",
                            icon: "error",
                            button: "Լավ",
                        })
                    }
                }).finally(() => {
                    this.setState({ requestLoading: false });
                })
            } else {
                let reqData = this.getPostReqData(this.state.fieldsData);
                reqData.link = this.state.fieldsData.link || ''
                reqData.mobile_object_name = this.state.fieldsData?.mobile?.key || null
                reqData.mobile_cover_object_name = this.state.fieldsData?.mobile_cover?.key || null

                if (Object.keys(reqData).length) {
                    this.props.UpdatePartnerOfferById(this.props.id, reqData).catch((error) => {
                        if (error && error.response && error.response.status === 409) {
                            swal({
                                title: "Չհաջողվեց!",
                                text: "Slug -ը զբաղված է",
                                icon: "error",
                                button: "Լավ",
                            })
                        }
                    })
                }

            }
        } else {
            this.setState({
                requestLoading: false,
                errors: errors,
                errorsTabs: validationTr.errorsTabs
            })
        }
    }


    render () {
        const {
            fieldsData,
            errors,
            languageTab,
            isEditing,
            errorsTabs,
            requestLoading,
            mediaModalType
        } = this.state;
        const initData = this.currentData?.translations?.find(item => item?.lang === languageTab) || {};
        const currentData = fieldsData.translations?.find(item => item?.lang === languageTab) || {};
        return <PageWrapper pageTitle={!isEditing ? 'Ավելացնել Առաջարկ' : 'Փոփոխել Առաջարկը'}>
            <section className="general-add-edit">
                {isEditing && <div className="fixed-top-right">
                    <label>{!fieldsData.is_hidden ? "Ակտիվ " : "Ոչ ակտիվ "}</label>
                    <Switch checked={!fieldsData.is_hidden}
                            onChange={(checked) => this.getInputValues({
                                name: "is_hidden",
                                value: !checked,
                                haveChanges: this.currentData?.is_hidden !== !checked
                            })}/>
                </div>}
                <div className="top-side">
                    <label>Image <span className={'required-badge'}>*</span></label>
                    <LinkButton title="Ընտրել մեդիադարանից"
                                className={`media-select-btn ${errors.image ? 'media-select-error' : ''}`}
                                cb={this.toggleMediaModalType.bind(this, 'image')}
                    />
                </div>
                {fieldsData?.image && <div className={'main-media'}>
                    <MediaFileCard item={fieldsData?.image}
                    />
                </div>}
                <div className="top-side">
                    <label>Mobile image</label>
                    <LinkButton title="Ընտրել մեդիադարանից"
                                className={`media-select-btn`}
                                cb={this.toggleMediaModalType.bind(this, 'mobile')}
                    />
                </div>
                {fieldsData?.mobile && <div className={'main-media'}>
                    <MediaFileCard item={fieldsData?.mobile}
                                   customDelete={this.deleteMedia.bind(this, 'mobile')}
                    />
                </div>}
                <div className="top-side">
                    <label>Mobile cover image</label>
                    <LinkButton title="Ընտրել մեդիադարանից"
                                className={`media-select-btn`}
                                cb={this.toggleMediaModalType.bind(this, 'mobile_cover')}
                    />
                </div>
                {fieldsData?.mobile_cover && <div className={'main-media'}>
                    <MediaFileCard item={fieldsData?.mobile_cover}
                                   customDelete={this.deleteMedia.bind(this, 'mobile_cover')}
                    />
                </div>}
                <div className={'join-block'}>
                    <InputGroup inputType="input"
                                type="text"
                                label="Slug"
                                placeholder="Slug"
                                name="slug"
                                required={true}
                                value={fieldsData?.slug}
                                initValue={this.currentData?.slug}
                                error={errors['slug']}
                                maxLength={100}
                                onChange={this.getInputValues}/>
                    <InputGroup inputType="input"
                                type="text"
                                label="URL"
                                placeholder="url"
                                name="link"
                                value={fieldsData.link}
                                initValue={fieldsData.link}
                                maxLength={100}
                                onChange={this.getInputValues}/>
                </div>
                <LanguageTabs changeLanguageTab={this.changeLanguageTab}
                              errorsTabs={errorsTabs}
                              activeTab={languageTab}/>

                <InputGroup inputType="input"
                            type="text"
                            label="Անվանում"
                            placeholder="Անվանում"
                            name="title"
                            required={true}
                            value={currentData.title}
                            initValue={initData.title}
                            error={errors['title' + languageTab]}
                            maxLength={100}
                            onChange={this.getTranslatableInputValues}/>

                <div className={'editors'}>
                    <div className={'editor-wrapper'}>
                        <label>Նկարագրություն <span className={'required-badge'}>*</span></label>
                        <Editor
                            value={currentData.description || ""}
                            name={'description'}
                            initValue={fieldsData?.description}
                            error={errors['description' + languageTab]}
                            disableToolbar={true}
                            onChange={this.getTranslatableInputValues}/>
                    </div>
                </div>

                <div className="flex-wrapper-right">
                    <LinkButton title={!isEditing ? 'Ավելացնել' : 'Փոփոխել'}
                                loading={requestLoading}
                                cb={this.addEditOffer}/>
                </div>
            </section>
            <MediaSelectorModal
                isOpen={!!mediaModalType}
                acceptTypes={ACCEPT_IMAGE_TYPES}
                getMedia={this.getMedia.bind(this, mediaModalType)}
                closeModal={this.toggleMediaModalType.bind(this)}
            />
        </PageWrapper>
    }
}

const mapDispatchToProps = {
    CreatePartnerOffer,
    GetPartnerOfferById,
    UpdatePartnerOfferById,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddEditPartnerOffer)
